<app-contentful-renderer [model]="model.target" *ngIf="model.target"></app-contentful-renderer>
<div *ngIf="html" [innerHTML]="html"></div>
<ng-template [ngIf]="!html && !model.target">
  <app-rich-text *ngFor="let item of model.content" [model]="item"></app-rich-text>
</ng-template>
